// AUTO-GENERATED by scripts/generate-contracts.mjs from the .md sidecar.
// Hand edits will be overwritten on the next run. To customise this
// component's contract (add actions, structured props, custom control
// kinds, glyph pickers), remove this file's auto-generated marker and
// hand-author it — the generator skips files without the marker.

import { z } from "zod";
import { contract } from "@gradeui/contracts";

export const StackContract = contract({
  name: "Stack",
  description: "Default top-level layout inside the main slot when composing two or more stacked regions (hero + content + footer, auth card + subtext, etc.). Prefer Stack over hand-rolled `flex flex-col gap-*` so the vertical rhythm is editable through the settings panel.",
  import: "@gradeui/ui",
  aliases: ["stack","vstack","vertical","column","vertical layout","v-stack","vertical stack","lazyvstack"],
  composesWith: ["Section","Row","Split","Hero","any content component"],
  props: {
  "gap": {
      schema: z.enum(["none", "xs", "sm", "md", "lg", "xl", "2xl"]).optional(),
      design: "knob",
      description: "vertical gap between children",
      default: "md",
  },
  "align": {
      schema: z.enum(["start", "center", "end", "stretch"]).optional(),
      design: "knob",
      description: "cross-axis (horizontal) alignment of children",
      default: "stretch",
  },
  "justify": {
      schema: z.enum(["start", "center", "end", "between", "around", "evenly"]).optional(),
      design: "knob",
      description: "main-axis (vertical) distribution. Reach for this on absolute-positioned overlays (`justify=\"end\"` pins children to the bottom) and split footers (`justify=\"between\"`).",
      default: "start",
  },
  "asChild": {
      schema: z.boolean().optional(),
      design: "plumbing",
      description: "render as the child element via Slot, so `<Stack asChild><section>…</section></Stack>` stamps Stack's classes onto the `<section>` rather than nesting a wrapper div",
      default: false,
  },
  "className": {
      schema: z.string().optional(),
      design: "plumbing",
  },
  "children": {
      schema: z.unknown(),
      design: "plumbing",
  },
  },
});
